import moment from "moment-timezone";
import { CustomHeader } from "tap/components/AGGrid/cell-renderers/CustomHeader.jsx";
import { ClickableCellRenderer } from "tap/components/AGGrid/cell-renderers/ClickableCellRenderer.jsx";

export const id = {
  field: "id",
  headerName: "ID",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "id",
    page: "tapJobs",
  },
  minWidth: 50,
};

export const jobType = {
  field: "jobType",
  headerName: "Job Type",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "jobType",
    page: "tapJobs",
  },
  minWidth: 200,
};

export const jobStatus = (onOpenJobViewModal) => ({
  field: "jobStatus",
  headerName: "Status",
  cellRenderer: ClickableCellRenderer(onOpenJobViewModal, "fa-eye"),
  minWidth: 200,
});

export const targetCount = (onOpenJobTasksModal) => ({
  field: "targetCount",
  headerName: "Target",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "targetCount",
    page: "tapJobs",
  },
  cellRenderer: ClickableCellRenderer(onOpenJobTasksModal, ""),
  minWidth: 50,
});

export const progressCount = {
  field: "progressCount",
  headerName: "Progress",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "progressCount",
    page: "tapJobs",
  },
  minWidth: 50,
};

export const errorCount = {
  field: "errorCount",
  headerName: "Errors",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "errorCount",
    page: "tapJobs",
  },
  minWidth: 50,
};

export const createdBy = {
  field: "startedByUser",
  headerName: "Created By",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "startedByUser",
    page: "tapJobs",
  },
  minWidth: 150,
};

export const createdAt = {
  field: "createdAt",
  headerName: "Created",
  valueFormatter: ({ value }) =>
    value
      ? moment(moment.utc(value).toDate())
          .tz(moment.tz.guess())
          .format("MM/DD/YYYY, h:mm:ss A z")
      : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "createdAt",
    page: "tapJobs",
  },
  minWidth: 225,
};

export const completedAt = {
  field: "completedAt",
  headerName: "Completed",
  valueFormatter: ({ value }) =>
    value
      ? moment(moment.utc(value).toDate())
          .tz(moment.tz.guess())
          .format("MM/DD/YYYY, h:mm:ss A z")
      : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "completedAt",
    page: "tapJobs",
  },
  minWidth: 225,
};
